import Vue from 'vue';
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import { Validator } from 'vee-validate';
export default function () {
  this.interviewScheduleValidaton = function () {
    const dictonary = {
      custom: {
        DateCommence: {
          required: () => t.t(dictEnum.LBL_Commencement) + t.t(dictEnum.WARN_IsRequired)
        },
        JobName: {
          required: () => t.t(dictEnum.LBL_Position) + t.t(dictEnum.WARN_IsRequired)
        },
        BasicSalary: {
          required: () => t.t(dictEnum.LBL_BasicSalary) + t.t(dictEnum.WARN_IsRequired),
          integer: () => t.t(dictEnum.LBL_BasicSalary)
        },
        SalPayCycle: {
          required: () => t.t(dictEnum.LBL_SalPayCycle) + t.t(dictEnum.WARN_IsRequired)
        },
        Allowance: {
          required: () => t.t(dictEnum.LBL_Allowance) + t.t(dictEnum.WARN_IsRequired),
          integer: () => t.t(dictEnum.LBL_Allowance)
        },
        AnotherInterviewer: {
          required: () => t.t(dictEnum.LBL_Interviewer) + t.t(dictEnum.WARN_IsRequired),
        },
        AnotherInterviewSch: {
          required: () => t.t(dictEnum.LBL_AnotherInterviewSch) + t.t(dictEnum.WARN_IsRequired)
        },
        AnotherInterviewTime: {
          required: () => t.t(dictEnum.LBL_AnotherInterviewTime) + t.t(dictEnum.WARN_IsRequired)
        },
        PayCycle: {
          required: () => t.t(dictEnum.LBL_SalPayCycle) + t.t(dictEnum.WARN_IsRequired)
        },
      }
    };
    Validator.localize('en', dictonary);
  }
}



// WEBPACK FOOTER //
// ./src/components/S110000-InterviewSchedule/S110000-InterviewScheduleValidaton.js